import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	promptHint: {
		id: 'fabric.editor.ai.config.item.empty.generateContent.promptHint',
		defaultMessage: 'Write with AI or select from below',
		description: 'Placeholder text in the prompt input guiding user interaction.',
	},
});
